import { useLanguage } from '../context/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';

export const Layout = ({ children }) => {
  const { direction, isArabic } = useLanguage();

  return (
    <div 
      dir={direction} 
      className={`min-h-screen flex flex-col ${isArabic ? 'font-arabic' : 'font-english'}`}
      style={{ fontFamily: isArabic ? "'Cairo', 'Almarai', sans-serif" : "'Outfit', 'Inter', sans-serif" }}
    >
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
